import { InstallationStatus } from 'ta_utils/routes/gfap';

export default {
  landingPage: {
    footer: {
      privacy: 'Datenschutzrichtlinie',
      termsOfUse: 'Nutzungsbedingungen',
      legalDisclosure: 'Impressum',
      copy: 'TA-Manager © 2025',
      followUs: 'Folgen Sie uns auf',
      linkedin: 'LinkedIn',
      twitter: 'Twitter',
      facebook: 'Facebook',
    },
    v2: {
      hero: {
        overline: 'Fehler und Probleme im beim Hausanschluss vermeiden',
        title: 'Gf-TA Installationen vereinfachen',
        subtitle1:
          'Individuelle Markenanpassung: Passen Sie Registrierungslinks, Logos und Formulare an, um die Identität Ihres Telekommunikationsunternehmens widerzuspiegeln.',
        subtitle2:
          'Mühelose Integration: Mit einem schnellen QR-Code-Scan auf der Gf-TA erhalten Installateure Zugang zu einem vollständig personalisierten Registrierungsprozess.',
        subtitle3:
          'Echtzeit-Tracking: Profitieren Sie von sicheren, verschlüsselten Benachrichtigungen und bleiben Sie mit sofortigen Updates informiert.',
        testimonialText:
          'TA-Manager hat unser Onboarding transformiert - die Installationszeiten drastisch verkürzt und die Kundenzufriedenheit gesteigert.',
        testimonialAuthor: 'Technik, Cable4',
      },
      keyFeatures: {
        title: 'Schlüsselfunktionen',
        feature1: {
          title: 'Anpassbare Registrierung & Branding',
          description:
            'Passen Sie Formulare, Logos und Weiterleitungs-URLs an, um Ihre einzigartige Identität widerzuspiegeln. Richten Sie für jeden Kunden personalisierte Abläufe ein!',
        },
        feature2: {
          title: 'Sichere, unternehmensgerechte Integration',
          description:
            'Erhalten Sie in Echtzeit verschlüsselte Benachrichtigungen. Sicher, zuverlässig und vertrauenswürdig.',
        },
        feature3: {
          title: 'Effizientes Installations-Tracking',
          description:
            'Überwachen Sie jede Gf-TA-Installation mit detaillierten Echtzeitdaten und Berichten.',
        },
        feature4: {
          title: 'Robuste Formular- und Medienverarbeitung',
          description:
            'Unterstützt Unterschriftserfassung, Bilder und eine umfassende Formularvalidierung zur Gewährleistung der Datenqualität.',
        },
        feature5: {
          title: 'Erweiterte Adressintegration',
          description:
            'Verknüpfen Sie Installationen mit Geolokalisierung und Adressen. Nutzen Sie entweder offene Daten oder integrieren Sie Ihre eigene Daten per API.',
        },
        feature6: {
          title: 'Branchenführende NE4 Expertise',
          description:
            'TA-Manager ist das Ergebnis der Zusammenarbeit von KWS Electronic, den Spezialisten für Glasfasertechnik, sowie der AND Solution GmbH, dem Branchenführer für Dokumentation und Planung der Netzebene 4.',
        },
      },
      steps: {
        title: 'Nahtlose Installationen in 4 einfachen Schritten',
        step1: {
          title: 'Passen Sie Ihr TA-Manager-Profil an',
          description:
            'In einem kurzen Onboarding-Meeting richten wir gemeinsam Formulare und Layouts für das Gf-TAs branding, die genau auf Sie zugeschnitten sind.',
        },
        step2: {
          title: 'Erhalten Sie Ihre individualisierten Gf-TAs',
          description:
            'Bei jeder Bestellung drucken und liefern wir Ihre individualisierten Gf-TAs.',
        },
        step3: {
          title: 'Installieren Sie die Gf-TA & scannen Sie den QR-Code',
          description:
            'Der Installateur montiert die Gf-TA, scannt den QR-Code und startet das maßgeschneiderte Registrierungsformular.',
        },
        step4: {
          title: 'Erhalten Sie Echtzeit-Updates',
          description:
            'Nach der Übermittlung benachrichtigen sichere Webhooks Ihr Team sofort und lösen eine individuelle Weiterleitung aus.',
        },
      },
      whyChoose: {
        title: 'Warum Glasfasernetzbetreiber TA-Manager wählen',
        point1:
          'Beschleunigtes Onboarding: Automatisieren Sie Registrierungen, um die manuelle Dateneingabe und Installationsverzögerungen drastisch zu reduzieren.',
        point2:
          'Unternehmenssupport von den Experten: Profitieren Sie von erstklassigem Support kombiniert mit branchenführender Sicherheit, Zuverlässigkeit und DSGVO-Konformität.',
        point3:
          'Maßgeschneiderte Kundenerfahrung: Vollständig anpassbare Formulare und Benachrichtigungen, die genau Ihrer Marke und Ihrem Workflow entsprechen.',
        point4:
          'Verbesserte Endnutzer-Interaktion: Vereinfachen Sie die Kundenauswahl mit intelligenten Weiterleitungen, vorab ausgefüllten Adressoptionen und intuitiven Benutzeroberflächen.',
      },
      testimonials: {
        title: 'Was unsere Partner sagen',
        testimonial1: {
          testimonialText:
            'TA-Manager hat unsere Netzwerküberwachung bei Cable4 neu definiert. Mit Echtzeit-Einblicken und optimierten Prozessen ist unser Team effizienter als je zuvor geworden.',
          author: 'Sascha Neuberger, Geschäftsführer Cable4',
        },
        testimonial2: {
          testimonialText:
            'Mit TA-Manager hat sich die Zuverlässigkeit unseres Netzwerks signifikant verbessert. Die klaren Rückmeldungen und effizienten Warnungen haben unsere Abläufe optimiert und unser Vertrauen in das Netzwerkmanagement gestärkt.',
          author: 'Robin Wilang, Geschäftsführer, West Connect',
        },
        testimonial3: {
          testimonialText:
            'Die Integration von TA-Manager war ein Wendepunkt. Die umsetzbaren Einblicke und die intuitive Benutzeroberfläche haben unserem Team geholfen, die Ressourcenzuweisung zu optimieren und die Gesamtleistung zu steigern.',
          author: 'Ingo A. Wölfel, Geschäftsführer, Versakom Service',
        },
        testimonial4: {
          testimonialText: 'Toll!',
          author: 'STG Infrastruktur',
        },
      },
      faqs: {
        title: 'Häufig gestellte Fragen',
        faq1: {
          question: 'Was ist TA-Manager?',
          answer:
            'Es ist eine umfassende Hardware-/Softwarelösung, die maßgeschneiderte Registrierungslinks und Logos auf Gf-TAs druckt, um den Fasereinrichtungsprozess für Glasfasernetzbetreiber zu optimieren.',
        },
        faq2: {
          question: 'Wie funktioniert die QR-Code-Registrierung?',
          answer:
            'Installateure scannen den QR-Code auf der Gf-TA, der ein personalisiertes Registrierungsformular startet, das auf das TKU zugeschnitten ist.',
        },
        faq3: {
          question: 'Ist die Lösung sicher und DSGVO-konform?',
          answer:
            'Absolut – TA-Manager setzt auf Sicherheit auf Unternehmensniveau und hält sich strikt an die DSGVO-Richtlinien. Sprechen Sie uns an für ein DPA.',
        },
        faq4: {
          question: 'Kann ich Formulare und Benachrichtigungen anpassen?',
          answer:
            'Ja, Sie können Formulare, Benachrichtigungen und das Branding vollständig an die Anforderungen Ihres Glasfasernetzbetreibers anpassen.',
        },
      },
      cta: {
        title: 'Transformieren Sie Ihre NE4 Prozesse noch heute!',
        subtitle:
          'Erleben Sie revolutionäres NE4-Tracking, das Ihr Unternehmen voranbringt. Gewinnen Sie exklusive Einblicke, profitieren Sie von nahtloser Integration und praxisorientierten Erkenntnissen. Fordern Sie jetzt Ihre kostenlose Live-Demo an und starten Sie in die Zukunft!',
        button: 'Live-Demo anfordern',
      },
    },
  },
  common: {
    error: 'Fehler',
    loading: 'Laden...',
    notFound: 'Seite nicht gefunden',
    backToHome: 'Zurück zur Startseite',
    login: 'Anmelden',
    logout: 'Abmelden',
    back: 'Zurück',
    home: 'Startseite',
    cancel: 'Abbrechen',
    admin_actions: 'Admin-Aktionen',
    action_install: 'Installieren',
    action_not_ready: 'Nicht signalbereit',
    action_ready: 'Betriebsbereit',
    installation_status: {
      installation: 'Installation',
      not_signal_ready: 'Nicht signalbereit',
      operational: 'Betriebsbereit',
    },
  },
  installation: {
    status: 'Installationsstatus',
    completed: 'Abgeschlossen',
    pending: 'Ausstehend',
    failed: 'Fehlgeschlagen',
    installation: 'Installation',
    status_checked_at: 'Status überprüft am',
  },
  form: {
    providerLock: {
      formPassword: 'Bitte geben Sie das Formular-Passwort ein',
      rateLimitExceeded:
        'Zu viele Versuche. Bitte versuchen Sie es später erneut',
      errorOccurred:
        'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut',
      invalidCode: 'Ungültiger Code. Bitte versuchen Sie es erneut',
      enterAccessCode: 'Geben Sie den Zugangscode ein',
    },
    enterValue: 'Wert eingeben',
    submit: 'Absenden',
    save: 'Speichern',
    reset: 'Zurücksetzen',
    submissionSuccess: 'Erfolgreich abgeschickt',
    saveSuccess: 'Erfolgreich zwischengespeichert',
    passwordExpired: 'Passwort abgelaufen',
    enterPassword: 'Passwort eingeben',
    redirecting: 'Weiterleitung in {seconds} Sekunden...',
    redirectingNow: 'Weiterleitung wird ausgeführt...',
    cancelRedirect: 'Weiterleitung abbrechen',
    submitting: 'Wird abgeschickt...',
    submissionFailed: 'Fehler beim Absenden. Bitte versuchen Sie es erneut',
    missingRequiredFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
    validation: {
      required: 'Dieses Feld ist erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      minLength: 'Muss mindestens {min} Zeichen lang sein',
    },
    address: {
      search: 'Adressen suchen...',
      id: 'ID',
      city: 'Stadt',
      street: 'Straße',
      zip: 'PLZ',
      select: 'Adresse auswählen...',
      loading: 'Adressen werden geladen...',
      noResults: 'Keine Adressen gefunden',
      error: {
        location: 'Standort konnte nicht ermittelt werden: {message}',
        geolocation:
          'Geolokalisierung wird von Ihrem Browser nicht unterstützt',
        fetch: 'Adressen konnten nicht abgerufen werden',
        distance: 'Fehler bei der Entfernungsberechnung',
      },
      noAddresses: 'Keine Adressen gefunden',
    },
    signature: {
      clear: 'Löschen',
      edit: 'Bearbeiten',
      save: 'Speichern',
      loading: 'Laden...',
      description:
        'Mit dieser Unterschrift bestätige ich die ordnungsgemäße Installation der Teilnehmer-Anschlussdose',
      noSignature: 'Keine Unterschrift vorhanden',
    },
    select_option: 'Bitte auswählen',
    enum: {
      installation: 'Installation',
      not_signal_ready: 'Installiert jedoch nicht Signalbereit',
      operational: 'Betriebsbereit',
    },
    image: {
      clear: 'Bild löschen',
      choose: 'Kein Bild ausgewählt',
    },
    fields: {
      installationStatus: 'Installationsstatus',
      password: 'Formular-Passwort',
    },
    pdf: {
      installationReport: 'Installationsreport',
      generatedOn: 'Erstellt am',
    },
    scanner: {
      scan: 'Scannen',
    },
  },
  footer: {
    links: {
      privacyPolicy: {
        text: 'Datenschutzerklärung',
      },
      termsOfService: {
        text: 'Nutzungsbedingungen',
      },
      contactUs: {
        text: 'Kontaktieren Sie uns',
      },
    },
  },
  report: {
    no_information: 'Keine Informationen verfügbar',
    no_information_description:
      'Für diesen Anschluss liegen derzeit keine Informationen vor. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
  },
  not_signal_ready: {
    title: 'Nicht aktiviert',
    description:
      'Ihr Anschluss ist noch nicht aktiviert. Bitte haben Sie etwas Geduld, während wir Ihre Aktivierung bearbeiten.',
  },
  loading: {
    message: 'Laden, bitte warten...',
  },
  cookieConsent: {
    message:
      'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern.',
    learnMore: 'Erfahren Sie mehr',
    policyLink: 'Datenschutzrichtlinie',
    essentialOnly: 'Nur wesentliche Cookies',
    acceptAll: 'Alle Cookies akzeptieren',
  },
  locale: {
    chooseLanguage: 'Sprache wählen',
    selectLanguage: 'Sprache auswählen',
    languages: {
      en: 'Englisch',
      de: 'Deutsch',
    },
  },
  dashboard: {
    create_batch_installations: 'Erstelle eine neue Batch mit Installationen',
    list_and_manage_provisioned_installations:
      'Liste und verwalte betriebsbereite Installationen',
    list_and_manage_reports: 'Liste und verwalte Berichte',
    list_and_manage_addresses: 'Liste und verwalte Adressen',
  },
  site_names: {
    dashboard: 'Dashboard',
    provisioned_installations: 'Bereitgestellte Installationen',
    create_batch: 'Batch erstellen',
    report: 'Report',
    reports: 'Berichte',
    addresses: 'Adressen',
    login: 'Login',
  },
  create_batch: {
    quantity_label: 'Anzahl der zu generierenden Codes',
    create: 'Batch erstellen',
    creating: 'Wird erstellt...',
    creation_success: 'Batch erfolgreich erstellt',
    download_csv: 'CSV herunterladen',
    creation_error: 'Fehler beim Erstellen des Batches',
    creation_error_description:
      'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.',
  },
  provisioned: {
    provisioned_installations: 'Bereitgestellte GFAP Installationen',
    no_provisioned_installations: 'Keine abgeschlossenen Installationen',
    no_provisioned_installations_description:
      'Es gibt derzeit keine bereitgestellten Installationen.',
    filter_show_all: 'Alle anzeigen',
    filter_show_operational: 'Betriebsbereit',
    filter_show_not_signal_ready: 'Nicht signalbereit',
    error_loading: 'Beim Laden der Daten ist ein Fehler aufgetreten',
    error_getting_batches: 'Fehler beim Abrufen der Batch-Identifikatoren',
  },
  reports: {
    title: 'GFAP Berichte',
    no_reports: 'Keine Berichte vorhanden',
    no_reports_description: 'Es gibt derzeit keine GFAP Berichte.',
    error_loading: 'Beim Laden der Daten ist ein Fehler aufgetreten',
    error_updating_status: 'Fehler beim Aktualisieren des Installationsstatus',
    error_batch_updating_status:
      'Fehler beim Aktualisieren des Batch-Installationsstatus',
    failed_updates: 'fehlgeschlagen',
    selected: 'ausgewählt',
    batch_install: 'Alle installieren',
    batch_not_ready: 'Alle nicht signalbereit',
    batch_ready: 'Alle betriebsbereit',
    clear: 'Löschen',
  },
  date_picker: {
    pick_a_date: 'Datum auswählen',
  },
  table_headers: {
    gfap_id: 'GFAP ID',
    created_at: 'Erstellt am',
    activation_code: 'Aktivierungscode',
    installation_transitioned_at: 'Übergegangen am',
    street: 'Straße',
    city: 'Stadt',
  },
  filters: {
    address: 'Adresse',
    street: 'Straße',
    city: 'Stadt',
    date: 'Datum',
    status: 'Status',
    search: 'Suche',
    street_placeholder: 'Straße...',
    city_placeholder: 'Stadt...',
    zip_placeholder: 'PLZ...',
  },
  addresses: {
    title: 'Adressen anzeigen',
    no_addresses: 'Keine Adressen gefunden',
    no_addresses_description:
      'Keine Adressen entsprechen Ihren Suchkriterien. Versuchen Sie einen anderen Suchbegriff.',
    add_address: 'Adresse hinzufügen',
    add_address_description:
      'Suchen Sie nach einem Standort oder klicken Sie auf die Karte, um einen Marker zu platzieren, und füllen Sie dann die Adressdaten aus.',
    search_location: 'Standort suchen',
    search_placeholder: 'Adresse eingeben...',
    map_hint:
      'Klicken Sie auf die Karte, um einen Marker zu platzieren, oder ziehen Sie den Marker, um die Position anzupassen.',
    coordinates: 'Koordinaten',
    geocoding_error:
      'Adresssuche fehlgeschlagen. Bitte versuchen Sie es erneut.',
    missing_fields:
      'Bitte füllen Sie alle erforderlichen Felder aus und platzieren Sie einen Marker auf der Karte.',
    submit_error:
      'Adresse konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.',
    address_added: 'Adresse erfolgreich hinzugefügt!',
    optional_auto_generated: 'optional, automatisch generiert wenn leer',
    id_placeholder: 'Eigene ID oder leer lassen...',
  },
  installation_status: {
    [InstallationStatus.INSTALLATION]: 'Installation ausstehend',
    [InstallationStatus.NOT_SIGNAL_READY]: 'Nicht signalbereit',
    [InstallationStatus.OPERATIONAL]: 'Betriebsbereit',
  },
};
